export const ApiLanguages = {
    get: params => ({
        url: '/languages',
        method: 'GET',
        params
    }),
    create: name => ({
        url: '/languages',
        method: 'POST',
        data: {
            name
        }
    }),
    update: (id, name) => ({
        url: `/languages/${id}`,
        method: 'PUT',
        data: {
            name
        }
    }),
    delete: (id) => ({
        url: `/languages/${id}`,
        method: 'DELETE',
    })
};